// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PreferencesRouteImport } from './routes/preferences'
import { Route as SearchDotaspxRouteImport } from './routes/search[.]aspx'
import { Route as ThaiDictionaryDesignedForLearnersOfThaiRouteImport } from './routes/thai-dictionary-designed-for-learners-of-thai'
import { Route as TransliterationRouteImport } from './routes/transliteration'
import { Route as Char3616Char3634Char3625Char3634Char3588Char3634Char3619Char3634Char3650Char3629Char3648Char3585Char3632RouteImport } from './routes/ภาษาคาราโอเกะ'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogBlogSlugRouteImport } from './routes/blog.$blogSlug'
import { Route as EnglishWordRouteImport } from './routes/english.$word'
import { Route as LearnBlogSlugRouteImport } from './routes/learn.$blogSlug'
import { Route as MyaccountSavedRouteImport } from './routes/myaccount.saved'
import { Route as SitePrivacyRouteImport } from './routes/site.privacy'
import { Route as SiteTermsRouteImport } from './routes/site.terms'
import { Route as ThaiWordRouteImport } from './routes/thai.$word'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PreferencesRoute = PreferencesRouteImport.update({
            id: '/preferences',path: '/preferences',getParentRoute: () => rootRouteImport
          })
const SearchDotaspxRoute = SearchDotaspxRouteImport.update({
            id: '/search.aspx',path: '/search.aspx',getParentRoute: () => rootRouteImport
          })
const ThaiDictionaryDesignedForLearnersOfThaiRoute = ThaiDictionaryDesignedForLearnersOfThaiRouteImport.update({
            id: '/thai-dictionary-designed-for-learners-of-thai',path: '/thai-dictionary-designed-for-learners-of-thai',getParentRoute: () => rootRouteImport
          })
const TransliterationRoute = TransliterationRouteImport.update({
            id: '/transliteration',path: '/transliteration',getParentRoute: () => rootRouteImport
          })
const Char3616Char3634Char3625Char3634Char3588Char3634Char3619Char3634Char3650Char3629Char3648Char3585Char3632Route = Char3616Char3634Char3625Char3634Char3588Char3634Char3619Char3634Char3650Char3629Char3648Char3585Char3632RouteImport.update({
            id: '/ภาษาคาราโอเกะ',path: '/ภาษาคาราโอเกะ',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogBlogSlugRoute = BlogBlogSlugRouteImport.update({
            id: '/blog/$blogSlug',path: '/blog/$blogSlug',getParentRoute: () => rootRouteImport
          })
const EnglishWordRoute = EnglishWordRouteImport.update({
            id: '/english/$word',path: '/english/$word',getParentRoute: () => rootRouteImport
          })
const LearnBlogSlugRoute = LearnBlogSlugRouteImport.update({
            id: '/learn/$blogSlug',path: '/learn/$blogSlug',getParentRoute: () => rootRouteImport
          })
const MyaccountSavedRoute = MyaccountSavedRouteImport.update({
            id: '/myaccount/saved',path: '/myaccount/saved',getParentRoute: () => rootRouteImport
          })
const SitePrivacyRoute = SitePrivacyRouteImport.update({
            id: '/site/privacy',path: '/site/privacy',getParentRoute: () => rootRouteImport
          })
const SiteTermsRoute = SiteTermsRouteImport.update({
            id: '/site/terms',path: '/site/terms',getParentRoute: () => rootRouteImport
          })
const ThaiWordRoute = ThaiWordRouteImport.update({
            id: '/thai/$word',path: '/thai/$word',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,PreferencesRoute: PreferencesRoute,SearchDotaspxRoute: SearchDotaspxRoute,ThaiDictionaryDesignedForLearnersOfThaiRoute: ThaiDictionaryDesignedForLearnersOfThaiRoute,TransliterationRoute: TransliterationRoute,Char3616Char3634Char3625Char3634Char3588Char3634Char3619Char3634Char3650Char3629Char3648Char3585Char3632Route: Char3616Char3634Char3625Char3634Char3588Char3634Char3619Char3634Char3650Char3629Char3648Char3585Char3632Route,BlogBlogSlugRoute: BlogBlogSlugRoute,EnglishWordRoute: EnglishWordRoute,LearnBlogSlugRoute: LearnBlogSlugRoute,MyaccountSavedRoute: MyaccountSavedRoute,SitePrivacyRoute: SitePrivacyRoute,SiteTermsRoute: SiteTermsRoute,ThaiWordRoute: ThaiWordRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)